import { Routes, RouterModule } from '@angular/router';
import { UnauthorizedComponent } from './unauthorized.component';


export const appRoutes: Routes = [
  {
    path: 'unauthorized', component: UnauthorizedComponent,
  },
];

